export const shadow = {
  border: "0px 0px 1px 0px rgba(0, 0, 0, 0.1)",
  level1: "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
  level2: "6px 6px 12px 0px rgba(0, 0, 0, 0.1)",
  level3: "0px 12px 18px 0px rgba(0, 0, 0, 0.1)",
  level4: "0px 10px 24px 0px rgba(0, 0, 0, 0.1)",
} as const;

export type ShadowKeys = keyof typeof shadow;
export type Shadow = typeof shadow;
